import Vue from 'vue'
import Vuex from 'vuex'
import VuexORM from '@vuex-orm/core'
import VuexORMAxios from '@vuex-orm/plugin-axios'
import { HttpClient } from '@/utils/HttpClient';

import Auth from './auth'
import User from './users'
import Message from './messages'
import Upload from './upload'
import Dashboard from './dashboard'
import Webhook from './webhooks'

Vue.use(Vuex)
VuexORM.use(VuexORMAxios, { axios: HttpClient })

const database = new VuexORM.Database()
database.register(Auth)
database.register(User)
database.register(Message)
database.register(Upload)
database.register(Dashboard)
database.register(Webhook)

export default new Vuex.Store({
    modules: {},
    plugins: [VuexORM.install(database)]
})
